import React from 'react';
import { IconProps } from '../types';

export const Sun: React.FC<IconProps> = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 4.5V2M7.8625 7.8625L6.1 6.1M4.5 16H2M7.8625 24.1375L6.1 25.9M16 27.5V30M24.1375 24.1375L25.9 25.9M27.5 16H30M24.1375 7.8625L25.9 6.1M23.5 16C23.5 20.1421 20.1421 23.5 16 23.5C11.8579 23.5 8.5 20.1421 8.5 16C8.5 11.8579 11.8579 8.5 16 8.5C20.1421 8.5 23.5 11.8579 23.5 16Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
